//Max Int32
export const MAX_INT = 2147483647
